import loginSlice from "../pages/login/Slice/slice";
import dashboardSlice from '../pages/dashboard/Slice/slice'
import CategoriesSlice from "../pages/categories/slice/slice";
import OrderListSlice from "../pages/orderlist/slice/slice";
import UserSlice from "../pages/users/slice/slice";

export const reducers = {
    loginSlice, CategoriesSlice, OrderListSlice, UserSlice, dashboardSlice
}